import DraftProjects from "your_projects/containers/draft_projects";
import PostedProjects from "your_projects/containers/posted_projects";
import WatchlistProjects from "your_projects/containers/watchlist_projects";
import {
  EmptyDraft,
  EmptyActive,
  EmptyWrapup,
  EmptyCompleted,
  EmptyInvited1to1Negotiations,
  EmptyInvitedProjectInvites,
  EmptyWatchlist,
  EmptyParticipating,
  EmptyWon,
  EmptyHistory,
} from "your_projects/components/empty";

export const DISMISSED_USERNAME_BANNER_COOKIE = "username_banner_dismissed";

export const PROJECTS_RESOURCE_NAME = "your_projects";

const BASE_URL = "/your-projects/";
const CLIENT_BASE_URL = `${BASE_URL}client/`;
const CREATIVE_BASE_URL = `${BASE_URL}creative/`;
const CLIENT_PROJECTS_URL = "/api/v1/projects/mine/";
const CREATIVE_PROJECTS_URL = "/api/v1/projects/participated/";

export const TABS_MAP = {
  client: {
    drafts: {
      name: "Drafts",
      showControls: false,
      url: `${CLIENT_BASE_URL}drafts/`,
      apiUrl: CLIENT_PROJECTS_URL,
      apiParams: {
        status: ["draft", "1_1_negotiating", "1_1_ready"],
      },
      sections: [
        {
          component: DraftProjects,
          emptyComponent: EmptyDraft,
        },
      ],
    },
    active: {
      name: "Active",
      showControls: false,
      url: `${CLIENT_BASE_URL}active/`,
      apiUrl: CLIENT_PROJECTS_URL,
      apiParams: {
        status: ["open", "closed", "finalist_round", "finalist_closed"],
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyActive,
        },
      ],
    },
    wrapup: {
      name: "In wrap-up",
      showControls: false,
      url: `${CLIENT_BASE_URL}wrapup/`,
      apiUrl: CLIENT_PROJECTS_URL,
      apiParams: {
        status: ["awarded"],
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyWrapup,
        },
      ],
    },
    complete: {
      name: "Completed",
      showControls: false,
      url: `${CLIENT_BASE_URL}complete/`,
      apiUrl: CLIENT_PROJECTS_URL,
      apiParams: {
        status: ["completed"],
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyCompleted,
        },
      ],
    },
  },
  creative: {
    invited: {
      name: "Invited",
      showIconIfNotEmpty: true,
      showControls: false,
      url: `${CREATIVE_BASE_URL}invited/`,
      apiUrl: "/api/v1/projects/invited/",
      component: PostedProjects,
      sections: [
        {
          title: "1-to-1 Negotiations",
          component: PostedProjects,
          emptyComponent: EmptyInvited1to1Negotiations,
          filterFn: (project) => project.status === "1_1_negotiating",
        },
        {
          title: "Project Invites",
          component: PostedProjects,
          emptyComponent: EmptyInvitedProjectInvites,
          filterFn: (project) => project.status !== "1_1_negotiating",
        },
      ],
    },
    watchlist: {
      name: "Watchlist",
      showControls: false,
      url: `${CREATIVE_BASE_URL}watchlist/`,
      apiUrl: "/api/v1/watchlist/",
      sections: [
        {
          component: WatchlistProjects,
          emptyComponent: EmptyWatchlist,
        },
      ],
    },
    participating: {
      name: "Participating",
      showControls: true,
      url: `${CREATIVE_BASE_URL}participating/`,
      apiUrl: CREATIVE_PROJECTS_URL,
      apiParams: {
        status: [
          "open",
          "closed",
          "finalist_round",
          "finalist_closed",
          "1_1_ready",
        ],
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyParticipating,
        },
      ],
    },
    wrapup: {
      name: "In wrap-up",
      showControls: true,
      url: `${CREATIVE_BASE_URL}wrapup/`,
      apiUrl: CREATIVE_PROJECTS_URL,
      apiParams: {
        status: ["awarded"],
        awarded: true,
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyWrapup,
        },
      ],
    },
    awarded: {
      name: "Awarded",
      showControls: true,
      url: `${CREATIVE_BASE_URL}awarded/`,
      apiUrl: CREATIVE_PROJECTS_URL,
      apiParams: {
        status: ["completed"],
        awarded: true,
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyWon,
        },
      ],
    },
    history: {
      name: "History",
      showControls: true,
      url: `${CREATIVE_BASE_URL}history/`,
      apiUrl: CREATIVE_PROJECTS_URL,
      apiParams: {
        status: ["awarded", "completed"],
        awarded: false,
      },
      sections: [
        {
          component: PostedProjects,
          emptyComponent: EmptyHistory,
        },
      ],
    },
  },
};
